import { allAuthRoute } from '@/pages/auth/route';
import type { RouteRecordRaw } from 'vue-router';

export const authRoutes: RouteRecordRaw = {
  path: '/auth',
  component: () => import('@/layouts/public.vue'),
  children: [...allAuthRoute]
};
